import 'reflect-metadata';
import { IsString, IsArray, IsObject, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class GoogleFontFiles {
  [key: string]: string;
}

export class GoogleFont {
  @IsString()
  family!: string;

  @IsArray()
  @IsString({ each: true })
  variants!: string[];

  @IsArray()
  @IsString({ each: true })
  subsets!: string[];

  @IsString()
  version!: string;

  @IsString()
  lastModified!: string;

  @IsObject()
  files!: GoogleFontFiles;

  @IsString()
  category!: string;

  @IsString()
  kind!: string;

  @IsString()
  menu!: string;
}

export class GoogleFontsResponse {
  @IsString()
  kind!: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => GoogleFont)
  items!: GoogleFont[];
}
